"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import _ from "lodash";
import API from "@ym-framework/api-utils";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import UiForm, {
  UiFormAnnotations,
  UiFormController
} from "@/components/form/UiForm.vue";
import i18n from "@/lang";
class GroupManageForm extends UiFormController {
  constructor() {
    super(...arguments);
    this.name = "";
    this.group_id = "";
  }
}
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("web_page_group_manage.name_rule"),
      trigger: "blur"
    }
  ])
], GroupManageForm.prototype, "name", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("web_page_group_manage.group_rule"),
      trigger: "blur"
    }
  ])
], GroupManageForm.prototype, "group_id", 2);
let GroupManageDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.dialog = new UiDialogController();
    this.formController = new GroupManageForm();
    this.groupProps = {
      label: "name",
      children: "children"
    };
    this.selectedItems = [];
    this.webPagePlatformGroup = [];
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  open() {
    return __async(this, null, function* () {
      try {
        yield this.getResourceGroupTree();
        this.dialog.visible = true;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  getResourceGroupTree() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(
          `api://base.auth/api/v1/web-resource-groups`
        );
        const newarr = _.filter(response.data.datas, { "parentId": "root" });
        console.log(newarr);
        this.webPagePlatformGroup = newarr;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  cancel() {
    this.webPagePlatformGroup = [];
    this.formController.name = "";
    this.formController.group_id = "";
    this.dialog.visible = false;
  }
  confirm() {
    return __async(this, null, function* () {
      try {
        let form = {
          name: this.formController.name,
          parentId: this.formController.group_id
        };
        if (this.formController.group_id === "top") {
          form.parentId = null;
        }
        yield API.post(`api://base.auth/api/v1/web-resource-groups`, form);
        this.$message.success(
          this.$t("web_page_group_manage.group_add_success")
        );
        this.$emit("refresh");
        this.cancel();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
GroupManageDialog = __decorateClass([
  Component({
    components: {
      UiDialog,
      UiForm
    }
  })
], GroupManageDialog);
export {
  GroupManageDialog as default
};
